import { Trans } from "@lingui/macro";
import { UiBox, UiSwitch, UiTypography } from "@smp/ui";
import { testAppendAttr, textCurrencySymbolGet } from "@smp/utils";

import { useEpBillingAccount } from "@/hooks/use_ep_billing_account";
import { PaymentProviderCard } from "@/screens/app/components/payment_provider_card";

import { useContextDialogPurchase } from "../../../context";

export const Providers = () => {
  const {
    actions: { areInternalFundsUsedToggle, paymentProviderSelectedChange },
    state: {
      areInternalFundsUsed,
      paymentProviderList,
      paymentProviderSelected,
      paymentTypeSelected,
      productSelected,
    },
  } = useContextDialogPurchase();

  const { accountList } = useEpBillingAccount();

  const account = accountList?.find(
    (account) => account.commodity === productSelected.currency,
  );

  if (!paymentProviderList) {
    return null;
  }

  return (
    <UiBox display="flex" flexDirection="column">
      <UiBox mb={2}>
        <UiTypography variant="h4">
          <Trans>Payment system</Trans>
        </UiTypography>
      </UiBox>
      <UiBox mb={2}>
        <UiBox display="flex" flexDirection="row" flexWrap="wrap">
          {paymentProviderList.map((provider) => (
            <PaymentProviderCard
              {...testAppendAttr("id", `purchase_provider_${provider.id}`)}
              isActive={provider.id === paymentProviderSelected?.id}
              key={provider.id}
              provider={provider}
              onSelect={paymentProviderSelectedChange}
            />
          ))}
        </UiBox>
      </UiBox>
      {paymentTypeSelected === "single" && !!account && account.balance > 0 && (
        <UiBox>
          <UiSwitch
            label={
              <Trans>
                Use internal funds ({account.balance}{" "}
                {textCurrencySymbolGet(account.commodity)} available)
              </Trans>
            }
            onClick={areInternalFundsUsedToggle}
            value={areInternalFundsUsed}
          />
        </UiBox>
      )}
    </UiBox>
  );
};
